<template>
  <div>
    <v-row no-gutters justify="start" align="center" class="content-header">
      <v-icon small color="accent" class="mr-2 font-weight-bold">lock</v-icon>
      <span class="font-weight-bold primary--text">Mon mot de passe</span>
    </v-row>
    <v-form v-model="isPasswordFormValid" @submit.prevent.native="savePassword">
      <v-container class="pb-4">
        <v-alert
          type="error"
          class="mb-2"
          v-if="hasPasswordError"
        >
          {{ this.passwordError }}
        </v-alert>
        <v-row>
          <v-col cols="12" class="pa-3">
            <v-text-field
              v-model="passwords.password"
              type="password"
              :rules="rules.required"
              label="Mot de passe actuel*"
              outlined
              hide-details
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pa-3">
            <v-text-field
              v-model="passwords.newPassword"
              type="password"
              :rules="rules.required"
              label="Nouveau mot de passe*"
              outlined
              hide-details
              required
            />
          </v-col>
          <v-col cols="12" md="6" class="pa-3">
            <v-text-field
              v-model="passwords.repeatNewPassword"
              type="password"
              :rules="rules.required"
              label="Répéter le nouveau mot de passe*"
              outlined
              hide-details
              required
            />
          </v-col>
        </v-row>
      </v-container>
      <v-divider />
      <v-row no-gutters justify="end" align="center" class="pt-4">
        <v-btn
          color="primary darken-1"
          type="submit"
          class="mr-2"
          :loading="isSavingPassword"
          :disabled="!isPasswordFormValid"
        >
          Changer mon mot de passe
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    passwords: {
      password: ``,
      newPassword: ``,
      repeatNewPassword: ``,
    },
    rules: {
      required: [value => !!value || `Ce champ est requis`],
    },
    isPasswordFormValid: true,
    isSavingPassword: false,
    passwordError: ``,
  }),
  computed: {
    hasPasswordError() {
      return this.passwordError.length > 0;
    },
  },
  methods: {
    async savePassword() {
      this.passwordError = ``;
      if (this.passwords.newPassword !== this.passwords.repeatNewPassword) {
        this.passwordError = `Les deux mots de passe doivent être identiques`;
      }
      if (!this.passwordError) {
        this.isSavingPassword = true;
        const { success, data } = await this.$store.dispatch(`model/user/savePassword`, this.passwords);
        if (!success) {
          if (_.trim(data).indexOf(`<`) === 0 || !data.length) {
            this.passwordError = `Une erreur serveur inconnue est apparue, veuillez réessayer.`;
          } else {
            this.passwordError = data;
          }
        } else {
          this.$store.dispatch(`showSnackbar`, {
            color: `success`,
            message: `Mot de passe modifié`,
          });
          this.passwords.password = ``;
          this.passwords.newPassword = ``;
          this.passwords.repeatNewPassword = ``;
        }
        this.isSavingPassword = false;
      }
    },
  },
};
</script>
